export default __webpack_public_path__ + "static/media/3-1.3c57746e.png";